import {userConstants} from '../_constants';

export function warehouseUser(state = {}, action) {
  switch (action.type) {
    case userConstants.WAREHOUSEMAN_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.WAREHOUSEMAN_USER_SUCCESS:
      return {
        ...state,
        result: action.data,
        is_no_access: action.data?.is_no_access || false,
        loading: false,
      };
    case userConstants.WAREHOUSEMAN_USER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
